/* IZEZE hero slideshow — left/right carousel with autoplay, dots, arrows, swipe */
(function () {
  function setup(root) {
    if (root.dataset.izInit) return;
    root.dataset.izInit = '1';
    var track = root.querySelector('.izeze-hero__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.izeze-slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.izeze-hero__dot'));
    var prev = root.querySelector('.izeze-hero__prev');
    var next = root.querySelector('.izeze-hero__next');
    var i = 0, timer = null;
    var speed = (parseInt(root.dataset.autoplay, 10) || 0) * 1000;

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function nextSlide() { go(i + 1); }
    function prevSlide() { go(i - 1); }
    function start() { if (speed > 0) { stop(); timer = setInterval(nextSlide, speed); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    next && next.addEventListener('click', function () { nextSlide(); start(); });
    prev && prev.addEventListener('click', function () { prevSlide(); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.idx, 10)); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // touch swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? nextSlide() : prevSlide(); }
      x0 = null; start();
    }, { passive: true });

    go(0); start();
  }

  function init() {
    document.querySelectorAll('.izeze-hero-slideshow').forEach(setup);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
